module.exports = __webpack_public_path__ + "static/media/twitter-brands.bcbfbd19.svg";